import { useEffect } from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import Services from './Services';
import Projects from './Projects';
import TechStack from './TechStack';
import CTA from './CTA';
import Footer from './Footer';
import GridBackground from './GridBackground';
import ScrollToTop from './ScrollToTop';
import './css/App.css';

function App() {
  // ...existing code...
  useEffect(() => {
    // Intersection Observer for fade-in animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Smooth scroll for anchor links
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' && target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const id = target.getAttribute('href')?.slice(1);
        if (id) {
          const element = document.getElementById(id);
          element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  useEffect(() => {
    // Scroll to hash on page load (for navigation from other pages)
    const hash = window.location.hash;
    if (hash) {
      // Small delay to ensure DOM is fully loaded
      setTimeout(() => {
        const id = hash.slice(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  // ...existing code...

  return (
    <>
      <GridBackground />
      <Navigation />
      <Hero />
      <Services />
      <Projects />
      <TechStack />
      <CTA />
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default App;
